<div class="container py-5" *ngIf="document$ | async as document">
  <h1 class="mb-2">{{ document.title }}</h1>
  <p class="text-muted mb-4">
    Version {{ document.version }}
    <span *ngIf="formatUpdatedAt(document.updatedAt) as updatedAt">• Updated {{ updatedAt | date:'mediumDate' }}</span>
  </p>
  <div class="legal-document-content">{{ document.content }}</div>
</div>
